export default {
  title: 'Potvrďte prosím svůj výběr varianty splácení',
  irregularTitle: 'Potvrďte prosím nabídku nepravidelných splátek',
  installmentAmount: 'Výše splátky',
  selectAnotherOffer: 'Nebo vyberte jinou variantu z e-mailu s nezávaznou nabídkou.',
  confirm: 'Potvrdit',
  payment: 'splátka',
  month: 'měsíc',
};
